var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-popover",
    {
      staticClass: "volume-popper",
      attrs: {
        width: "30",
        "popper-class": "volumePopper",
        effect: "dark",
        placement: "top",
        "visible-arrow": false,
        trigger: "click",
      },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "div",
        [
          _c("div", { staticClass: "volumeText" }, [
            _vm._v(" " + _vm._s(_vm.volume) + " "),
          ]),
          _c("el-slider", {
            attrs: {
              value: _vm.volume,
              vertical: "",
              height: "83px",
              min: 0,
              max: 200,
              "show-tooltip": false,
            },
            on: { input: _vm.onChange },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "volume",
          attrs: { slot: "reference" },
          slot: "reference",
        },
        [
          _vm.volume === 0
            ? _vm._t("jingyin", function () {
                return [
                  _c("svg-icon", {
                    attrs: {
                      "icon-class": "jingyin",
                      "class-name": "volume-icon",
                    },
                  }),
                ]
              })
            : _vm._t("yinlaing", function () {
                return [
                  _c("svg-icon", {
                    attrs: {
                      "icon-class": "yinlaing",
                      "class-name": "volume-icon",
                    },
                  }),
                ]
              }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }